var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopSubscribe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.006 0C15.107 0 16 .902 16 2.009V9.99c0 1.11-.895 2.009-1.994 2.009H1.994A2.003 2.003 0 0 1 0 9.991V2.01C0 .899.895 0 1.994 0zM6 2.8v6.4L10.2 6z"
})));
export default SvgYoutubeDesktopSubscribe;